'use client';
import { useState, useEffect } from 'react';
import { showLoading, showSuccess, showError } from '@/lib/toast';

export default function MemoryPage() {
  const [data, setData] = useState<any>({ short: {}, episodic: [], long: [] });
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState<any[]>([]);

  async function runSearch() {
    if (!searchQuery) return;
    
    const toastId = showLoading('Đang tìm kiếm...');
    
    try {
      const res = await fetch('/api/memory-search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: searchQuery, limit: 10 }),
      });
      
      if (!res.ok) {
        throw new Error('Không thể tìm kiếm');
      }
      
      const j = await res.json();
      setSearchResults(j.results || []);
      showSuccess(`Tìm thấy ${j.results?.length || 0} kết quả!`, toastId);
    } catch (error) {
      showError('Lỗi khi tìm kiếm memory', toastId);
      console.error('Search error:', error);
    }
  }

  async function load() {
    try {
      const res = await fetch('/api/memory-explorer');
      if (!res.ok) throw new Error('Không thể tải dữ liệu');
      const json = await res.json();
      setData(json);
    } catch (error) {
      showError('Lỗi khi tải memory data');
      console.error('Load error:', error);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function flushShort() {
    const toastId = showLoading('Đang xóa Short Memory...');
    
    try {
      const res = await fetch('/api/memory-explorer', { 
        method: 'POST', 
        headers: {'Content-Type': 'application/json'}, 
        body: JSON.stringify({ action: 'flushShort' }) 
      });
      
      if (!res.ok) throw new Error('Không thể flush');
      
      await load();
      showSuccess('Đã xóa Short Memory!', toastId);
    } catch (error) {
      showError('Lỗi khi xóa Short Memory', toastId);
      console.error('Flush short error:', error);
    }
  }

  async function flushEpisodic() {
    const toastId = showLoading('Đang xóa Episodic Memory...');
    
    try {
      const res = await fetch('/api/memory-explorer', { 
        method: 'POST', 
        headers: {'Content-Type': 'application/json'}, 
        body: JSON.stringify({ action: 'flushEpisodic' }) 
      });
      
      if (!res.ok) throw new Error('Không thể flush');
      
      await load();
      showSuccess('Đã xóa Episodic Memory!', toastId);
    } catch (error) {
      showError('Lỗi khi xóa Episodic Memory', toastId);
      console.error('Flush episodic error:', error);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Memory Explorer</h1>
      <button onClick={load}>Reload</button>
      <button onClick={flushShort} style={{ marginLeft: 8 }}>
        Flush Short
      </button>
      <button onClick={flushEpisodic} style={{ marginLeft: 8 }}>
        Flush Episodic
      </button>

      <h2>Search Memory</h2>
      <div>
        <input
          style={{ width: '60%' }}
          placeholder="query text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button onClick={runSearch} style={{ marginLeft: 8 }}>Search</button>
      </div>
      <pre style={{ background: '#f7f7f7', padding: 10, maxHeight: 200, overflowY: 'auto' }}>
        {JSON.stringify(searchResults, null, 2)}
      </pre>

      <h2>Short Memory</h2>
      <pre>{JSON.stringify(data.short, null, 2)}</pre>
      <h2>Episodic Memory</h2>
      <pre>{JSON.stringify(data.episodic, null, 2)}</pre>
      <h2>Long Memory</h2>
      <pre>{JSON.stringify(data.long, null, 2)}</pre>
    </div>
  );
}